// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OZal","textarea":"styles_textarea__2ySM3"};